import React, {useState, useEffect} from "react";
import {Alert, Button, Col, FormLabel, Row, Spinner, Modal, Accordion} from "react-bootstrap";
import Dropdown from "../../../primer/Dropdown";
import Input from "../../../common/Input";
import DateBox from "../../../primer/DateBox";
import Checkbox from "../../../common/CheckBox";
import {useDispatch, useSelector} from "react-redux";
import {
    setNewPrimerAiUrl,
    resetNewPrimerAiUrl,
    setAiQuotationsRequestData,
    setAiQuotationsResponseData, newPrimerAiUrlInitialValue
} from "../../../../_reducers/DataPanel/Sales/salesSlice";
import {setSavePrimerAiUrl} from "../../../../_reducers/activitySlice";
import {
    isEmpty,
    isValidEmail,
    validateAFM,
    getDefaultOptionByValue,
    getCurrentUser,
    getGreekCurrencyFormat
} from "../../../../_helpers/commonFunctions";
import AccountingBox from "../../../primer/AccountingBox";
import {generatePrimerAiUrl} from "../../../../_apis/api";
import {toast} from "react-toastify";
import moment from "moment/moment";
import axios from "axios";
import AdvancedCombobox from "../../../primer/AdvancedCombobox";
import Pagination from "../../../primer/Pagination";
import {useTranslation} from "../../../../hooks/useTranslation";

const AiUrlGenerator = () => {
    const {t} = useTranslation();
    const [showErrors, setShowErrors] = useState(false);
    const [loadingSave, setLoadingSave] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showQuotationsModal, setShowQuotationsModal] = useState(false);
    const [pageChanged, setPageChanged] = useState(false);
    const requestData = useSelector((state) => state.SALES.aiQuotationsRequestData);
    const responseData = useSelector((state) => state.SALES.aiQuotationsResponseData);
    const [usersList, setUsersList] = useState([]);
    const [selectedQuotation, setSelectedQuotation] = useState(null);
    const [email, setEmail] = useState("");
    const dispatch = useDispatch();
    const SALES = useSelector((state) => state.SALES);
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const newPrimerAiUrl = SALES.newPrimerAiUrl;
    const ACTIVITY = useSelector((state) => state.ACTIVITY);
    const [priceIncrKey, setPriceIncrKey] = useState(0);
    const user = getCurrentUser();
    const isAdmin = user?.userType === "Admin";
    const apiURL2 = process.env.REACT_APP_API_URL2;
    const erpVersionOptions = [
        {
            label: 'Accountant',
            value: 'accountant',
        },
        {
            label: 'Gold',
            value: 'gold',
        }
    ];
    const limitCompaniesOptions = [
        {
            label: "Έως 20 εταιρείες: 80€ / Μήνα",
            value: "20",
        },
        {
            label: "Έως 50 εταιρείες: 110€ / Μήνα",
            value: "50",
        },
        {
            label: "Έως 150 εταιρείες: 165€ / Μήνα",
            value: "150",
        },
        {
            label: "Έως 250 εταιρείες: 250€ / Μήνα",
            value: "250",
        },
        {
            label: "Από 250 εταιρείες και πάνω 400€ / Μήνα",
            value: "1000",
        }
    ];
    const creditsPerMonthOptions = [
        {
            label: "Κενό",
            value: "",
        },
        {
            label: "5000",
            value: "5000",
        },
        {
            label: "10000",
            value: "10000",
        },
        {
            label: "25000",
            value: "25000",
        },
        {
            label: "60000",
            value: "60000",
        },
        {
            label: "100000",
            value: "100000",
        },
        {
            label: "200000",
            value: "200000",
        }
    ];
    const monthOfSecondInstallmentOptions = [
        {
            label: "2",
            value: "2"
        },
        {
            label: "3",
            value: "3",
        },
        {
            label: "4",
            value: "4",
        },
        {
            label: "5",
            value: "5",
        },
        {
            label: "6",
            value: "6",
        }
    ];
    const billingIntervalOptions = [
        {
            label: "1",
            value: "1",
        },
        {
            label: "2",
            value: "2",
        },
        {
            label: "3",
            value: "3",
        },
        {
            label: "4",
            value: "4",
        },
        {
            label: "5",
            value: "5",
        },
        {
            label: "6",
            value: "6",
        },
        {
            label: "7",
            value: "7",
        },
        {
            label: "8",
            value: "8",
        },
        {
            label: "9",
            value: "9",
        },
        {
            label: "10",
            value: "10",
        },
        {
            label: "11",
            value: "11",
        },
        {
            label: "12",
            value: "12",
        },
        {
            label: "13",
            value: "13",
        },
        {
            label: "14",
            value: "14",
        },
        {
            label: "15",
            value: "15",
        },
        {
            label: "16",
            value: "16",
        },
        {
            label: "17",
            value: "17",
        },
        {
            label: "18",
            value: "18",
        },
        {
            label: "19",
            value: "19",
        },
        {
            label: "20",
            value: "20",
        },
        {
            label: "21",
            value: "21",
        },
        {
            label: "22",
            value: "22",
        },
        {
            label: "23",
            value: "23",
        },
        {
            label: "24",
            value: "24",
        },
        {
            label: "25",
            value: "25",
        },
        {
            label: "26",
            value: "26",
        },
        {
            label: "27",
            value: "27",
        },
        {
            label: "28",
            value: "28",
        },
        {
            label: "29",
            value: "29",
        },
        {
            label: "30",
            value: "30",
        }
    ];
    const billingPeriodOptions = [
        {
            label: "Μήνας",
            value: "month"
        },
        {
            label: "Έτος",
            value: "year"
        }
    ]
    const numberOfUsersOptions = [
        {
            label: "1 Χρήστης",
            value: "1"
        },
        {
            label: "2 Χρήστες",
            value: "2"
        },
        {
            label: "3 Χρήστες",
            value: "3"
        },
        {
            label: "4 Χρήστες",
            value: "4"
        },
        {
            label: "5 Χρήστες",
            value: "5"
        },
        {
            label: "6 Χρήστες",
            value: "6"
        },
        {
            label: "7 Χρήστες",
            value: "7"
        },
        {
            label: "8 Χρήστες",
            value: "8"
        },
        {
            label: "9 Χρήστες",
            value: "9"
        },
        {
            label: "10 Χρήστες",
            value: "10"
        }
    ];
    const numberOfEmployeesOptions = [
        {
            label: "Κενό",
            value: ""
        },
        {
            label: "Μέχρι και 4 εργαζόμενους",
            value: "Μέχρι και 4 εργαζόμενους",
        },
        {
            label: "Από 5 μέχρι και 19 εργαζόμενους",
            value: "Απο 5 μέχρι και 19 εργαζόμενους"
        },
        {
            label: "Από 20 και πάνω εργαζόμενους",
            value: "Απο 20 και πάνω εργαζόμενους",
        }
    ];
    const industryOptions = [
        {
            label: "Ενοικίαση Αυτοκινήτων",
            value: "car renting"
        },
        {
            label: "Πάρκινγκ - Πλυντήρια Αυτοκινήτων",
            value: "parking - car washes"
        },
        {
            label: "Συνεργεία Αυτοκινήτων",
            value: "car repair shop"
        }
    ];
    const cloudCapacityOptions = [
        {
            label: "Κενό",
            value: ""
        },
        {
            label: "20GB 7€ / Μήνα",
            value: "20GB",
        },
        {
            label: "50GB 15€ / Μήνα",
            value: "50GB",
        },
        {
            label: "200GB 30€ / Μήνα",
            value: "200GB",
        },
        {
            label: "500GB 60€ / Μήνα",
            value: "500GB",
        }
    ];
    const accountsNumberOptions = (erpVersion) => {
        if (erpVersion === "gold") {
            return [
                {
                    label: "Κενό",
                    value: ""
                },
                {
                    label: "1 Λογαριασμός 80€ / χρόνο",
                    value: "1"
                },
                {
                    label: "Από 2 μέχρι και 3 λογαριασμούς 150€ / χρόνο",
                    value: "3"
                },
                {
                    label: "Από 4 και πάνω λογαριασμούς 350€ / χρόνο",
                    value: "5000"
                }
            ];
        } else if (erpVersion === "accountant") {
            return [
                {
                    label: "Κενό",
                    value: ""
                },
                {
                    label: "Έως 20 Λογαριασμούς: 20€ / Μήνα",
                    value: "20"
                },
                {
                    label: "Έως 100 Λογαριασμούς: 80€ / Μήνα",
                    value: "100"
                },
                {
                    label: "Έως 200 Λογαριασμούς: 140€ / Μήνα",
                    value: "200"
                },
                {
                    label: "Έως 400 Λογαριασμούς: 280€ / Μήνα",
                    value: "400"
                },
                {
                    label: "Έως 600 Λογαριασμούς: 420€ / Μήνα",
                    value: "600"
                }
            ];
        }
    };

    const documentsPerMonthOptions = [
        {
            label: "MyData 500 Παραστατικά / Μήνα",
            value: "MyData 500 παραστατικά/μήνα"
        },
        {
            label: "MyData 3000 Παραστατικά / Μήνα",
            value: "MyData 3000 παραστατικά/μήνα"
        },
        {
            label: " MyData Απεριόριστα Παραστατικά / Μήνα",
            value: "MyData Απεριόριστα παραστατικά/μήνα"
        }
    ];

    const userDropdownColumns = [
        {
            label: "Username",
            name: "userName",
        },
        {
            label: "Όνομα",
            name: "firstName",
        },
        {
            label: "Επώνυμο",
            name: "lastName",
        },
    ];

    const tableColumns = [
        {
            name: "Ημερομηνία",
            field: "created_at",
            width: "20%",
        },
        {
            name: "ERP Version",
            field: "erpVersion",
            width: "10%",
        },
        {
            name: "Α.Φ.Μ.",
            field: "vatNumber",
            width: "20%",
        },
        {
            name: "Τελική τιμή πακέτου",
            field: "total",
            width: "10%",
        },
        {
            name: "Χρήστης",
            field: "user",
            width: "40%",
        }
    ];

    const getPriceBreakdown = (form) => {
        const items = [{label: "Υποστήριξη", monthlyPrice: 16.667}];
        const usersCount = Number(form.numberOfUsers) || 1;

        const add = (label, amount) => {
            const value = Number(amount) || 0;
            if (value > 0) {
                items.push({label, monthlyPrice: value});
            }
        };

        // ERP GOLD
        if (form.erpVersion === "gold") {
            const documentsPrices = {
                "MyData 500 παραστατικά/μήνα": 39.99,
                "MyData 3000 παραστατικά/μήνα": 49.99,
                "MyData Απεριόριστα παραστατικά/μήνα": 59.99
            };
            add(`Παραστατικά: ${form.documentsPerMonth || ""}`, documentsPrices[form.documentsPerMonth]);

            if (usersCount > 1) {
                add(`Επιπλέον χρήστες (${usersCount - 1} × 30€)`, (usersCount - 1) * 30);
            }

            const accountsPrices = {
                "1": 6.67,
                "3": 12.50,
                "5000": 29.17
            };
            add("Διασύνδεση Λογαριασμών (Όψεως)", accountsPrices[form.accountsNumber]);
        }

        // ERP ACCOUNTANT
        if (form.erpVersion === "accountant") {
            if (usersCount > 1) {
                add(`Επιπλέον χρήστες (${usersCount - 1} × 15€)`,
                    (usersCount - 1) * 15);
            }

            const accountsPrices = {
                "20": 20,
                "100": 80,
                "200": 140,
                "400": 280,
                "600": 420
            };

            add("Διασύνδεση Λογαριασμών (Όψεως)", accountsPrices[form.accountsNumber]);
        }

        // DIGITAL EMPLOYEE CARD
        const employeePrices = {
            "Μέχρι και 4 εργαζόμενους": 3.33,
            "Από 5 μέχρι και 19 εργαζόμενους": 6.67,
            "Από 20 και πάνω εργαζόμενους": 10.83
        };

        const employees = String(form.numberOfEmployees || "").replace(/^Απο /, "Από ");
        add(`Ψηφιακή Κάρτα Εργασίας: ${employees}`, employeePrices[employees]);

        // DIGITAL CUSTOMER REGISTER
        if (form.dclRental) {
            add("Ενοικίαση Αυτοκινήτων", 5.83);
        }
        if (form.dclParking) {
            add("Πάρκινγκ - Πλυντήρια", 5.83);
        }
        if (form.dclGarage) {
            add("Συνεργεία Αυτοκινήτων", 5.83);
        }

        // CLOUD STORAGE
        const cloudPrices = {
            "20GB": 7,
            "50GB": 15,
            "200GB": 30,
            "500GB": 60
        };

        add(`Cloud Storage ${form.cloudCapacity || ""}`, cloudPrices[form.cloudCapacity]);

        // ADDITIONAL MODULES
        if (form.myDataReport && form.erpVersion !== "accountant") {
            add("Module MyData Report", 29.17);
        }

        if (form.b2g && form.erpVersion !== "accountant") {
            add("Τιμολόγηση Δημοσίου (B2G)", 10);
        }

        if (form.deliveryNote) {
            add("Διαχείριση Ψηφιακών Διακινήσεων", 7);
        }

        if (form.accountingForms) {
            add("Λογιστικά Έντυπα (Taxis)", 10);
        }

        if (form.bankTransactions) {
            add("Διαχείριση Λογαριασμών (Όψεως)", 10);
        }

        // COMPANY LIMITS
        const companyPrices = {
            "20": 80,
            "50": 110,
            "150": 165,
            "250": 250,
            "1000": 400
        };

        add(`Όριο Εταιρειών (${form.limitCompanies || ""})`, companyPrices[form.limitCompanies]);
        // AI CREDITS
        const creditsPrices = {
            "5000": 150,
            "10000": 300,
            "25000": 600,
            "60000": 1300,
            "100000": 1900,
            "200000": 3900
        };
        add(`AI Credits (${form.creditsPerMonth || ""}/μήνα)`, creditsPrices[form.creditsPerMonth]);
        const interval = Number(form.billingInterval) || 1;
        const months = form.billingPeriod === "year" ? interval * 12 : interval;
        const monthlySubtotal = Number(items.reduce((sum, item) => sum + item.monthlyPrice, 0).toFixed(2));
        const autoPrice = Number((monthlySubtotal * months).toFixed(2));

        return {items, months, monthlySubtotal, autoPrice};
    };

    const calculateAutoPrice = (form) => {
        return getPriceBreakdown(form).autoPrice;
    };

    useEffect(() => {
        if (user?._id && isEmpty(newPrimerAiUrl.user && isEmpty(newPrimerAiUrl.company))) {
            dispatch(setNewPrimerAiUrl({
                ...newPrimerAiUrl,
                userId: user._id,
                user: `${user.firstName} ${user.lastName} (${user.userName})`,
                company: company.id
            }));
        }
    }, [user, company, dispatch]);

    useEffect(() => {
        if (showQuotationsModal) {
            loadUsersListData(null, setUsersList);
            fetchQuotations();
        }
    }, [showQuotationsModal]);

    useEffect(() => {
        if (pageChanged) {
            setPageChanged(false);
            fetchQuotations(true);
        }
    }, [pageChanged]);

    const recalculatePricing = (newPrimerAiUrl, overridePrice = 0) => {
        const autoPrice = calculateAutoPrice(newPrimerAiUrl);
        console.log(autoPrice);
        const currentPrice = overridePrice ? overridePrice : autoPrice;
        const vat = Number((currentPrice * 0.24).toFixed(2));
        const total = Number((currentPrice + vat).toFixed(2));

        return {
            ...newPrimerAiUrl,
            price: currentPrice.toString(),
            vat: vat,
            total: total
        };
    };

    const handleOnChange = (e, type, name) => {
        let overridePrice = 0;
        setShowErrors(true);
        let aiUrl = structuredClone(newPrimerAiUrl);
        if (aiUrl.generatedUrl) {
            aiUrl = { ...aiUrl, generatedUrl: "" };
        }

        if (!ACTIVITY.savePrimerAiUrl) dispatch(setSavePrimerAiUrl(true));
        if (type === "dropdown" && name === "industryOptions") {
            const selectedValues = e.map(item => item.value);
            aiUrl = {
                ...aiUrl,
                dclRental: selectedValues.includes("car renting"),
                dclParking: selectedValues.includes("parking - car washes"),
                dclGarage: selectedValues.includes("car repair shop")
            };
        } else if (type === "dd") {
            if (name === "erpVersion") {
                const isAccountant = e.value === "accountant";
                const isManualAllowed = Number(aiUrl.billingInterval) >= 12 || aiUrl?.billingPeriod === "year";

                aiUrl = {
                    ...aiUrl,
                    [name]: e.value,
                    myDataReport: isAccountant,
                    b2g: isAccountant,
                    limitCompanies: isAccountant ? aiUrl.limitCompanies : "",
                    documentsPerMonth: isAccountant ? "" : aiUrl.documentsPerMonth,
                    price: !isManualAllowed ? "" : aiUrl.price
                };
            } else if (name === "billingInterval" || name === "billingPeriod") {
                const interval = name === "billingInterval" ? Number(e.value) : Number(aiUrl.billingInterval);
                const period = name === "billingPeriod" ? e.value : aiUrl.billingPeriod;
                const isManualAllowed = interval >= 12 || period === "year";
                const isAccountant = aiUrl.erpVersion === "accountant";
                const creditsMandatory = isAccountant && period === "month" && interval < 12;

                aiUrl = {
                    ...aiUrl,
                    [name]: e.value,
                    price: !isManualAllowed ? "" : aiUrl.price,
                    creditsPerMonth: !creditsMandatory && isAccountant ? "" : aiUrl.creditsPerMonth
                };
            } else {
                aiUrl = { ...aiUrl, [name]: e.value };
            }
        } else if (type === "datebox") {
            const dateValue = moment(e);
            aiUrl = {
                ...aiUrl,
                [name]: (e && dateValue.isValid()) ? dateValue.toDate() : null
            };
        } else if (type === "input") {
            if (name === "advance" && (Number(e.target.value) <= 0 || e.target.value === "")) {
                aiUrl = {
                    ...aiUrl,
                    advance: e.target.value,
                    monthOfSecondInstallment: ""
                };
            } else if(name === "price") {
                setPriceIncrKey(priceIncrKey + 1);
                const autoPrice = Number(aiUrl.price);
                const currentPrice = Number(e.target.value);
                if(aiUrl?.billingPeriod >= 12 || aiUrl?.billingPeriod === "year") {
                    const minAllowed = autoPrice * 0.8;
                    const maxAllowed = autoPrice * 1.2;
                    if (currentPrice < minAllowed || currentPrice > maxAllowed) {
                        toast.error(`Εκτός ορίου ±20% (${minAllowed.toFixed(2)}€ - ${maxAllowed.toFixed(2)}€)`);
                        aiUrl = { ...aiUrl, [name]: autoPrice };
                    } else {
                        overridePrice = currentPrice;
                    }
                } else {
                    overridePrice = currentPrice;
                }
            } else {
                aiUrl = { ...aiUrl, [name]: e.target.value };
            }
        } else if (type === "checkbox") {
            aiUrl = { ...aiUrl, [name]: e.target.checked };
        }
        dispatch(setNewPrimerAiUrl(recalculatePricing(aiUrl, overridePrice)));
    };

    const handleOnChangeModal = (e, type, name) => {
        if (type === "datebox") {
            if (moment(e).isValid()) {
                dispatch(setAiQuotationsRequestData({...requestData, [name] : moment(e).format("DD/MM/YYYY")}))
            } else {
                dispatch(setAiQuotationsRequestData({...requestData, [name] : ""}));
            }
        } else if (type === "advancedCombobox") {
            if (e.row.userName === "System task") dispatch(setAiQuotationsRequestData({...requestData, [name] : e.row.userName}));
            else dispatch(setAiQuotationsRequestData({...requestData, [name] : `${e.row.firstName} ${e.row.lastName} (${e.row.userName})`}));
        }
    };

    const handleRowClick = (row) => {
        if (selectedQuotation?._id === row._id) {
            setSelectedQuotation(null);
            setEmail("");
        } else {
            setEmail("");
            setSelectedQuotation(row);
        }
    };

    const handlePageChange = (page) => {
        dispatch(setAiQuotationsRequestData({ ...requestData, page: page }));
        setPageChanged(true);
    };

    const buttonDisabled = () => {
        const form = newPrimerAiUrl;
        if (!isEmpty(form.generatedUrl)) return true;

        const baseRequiredFields = [
            form.vatNumber,
            form.erpVersion,
            form.numberOfUsers,
            form.billingInterval,
            form.billingPeriod,
            form.linkExpireAfter
        ];

        if (baseRequiredFields.some((field) => isEmpty(field))) {
            return true;
        }

        if (Number(form.advance) > 0 && isEmpty(form.monthOfSecondInstallment)) {
            return true;
        }

        if (form.erpVersion === 'accountant') {
            if (isEmpty(form.limitCompanies)) return true;
            if (form.myDataReport !== true || form.b2g !== true) return true;
        }

        if (form.erpVersion === 'gold') {
            if (isEmpty(form.creditsPerMonth)) return true;
            if (isEmpty(form.documentsPerMonth)) return true;
        }

        if (Number(form.price) <= 0) {
            return true;
        }

        if (!validateAFM(form.vatNumber)) return true;

        if (form.sentLinkToEmail) {
            if (isEmpty(form.email) || !isValidEmail(form.email)) {
                return true;
            }
        }

        return false;
    };

    const priceBreakdown = getPriceBreakdown(newPrimerAiUrl);
    const currentNetPrice = Number(newPrimerAiUrl.price) || 0;
    const manualPriceAdjustment = Number((currentNetPrice - priceBreakdown.autoPrice).toFixed(2));

    const createUrl = async () => {
        if (buttonDisabled()) {
            setShowErrors(true);
            return;
        }
        let payload = { ...newPrimerAiUrl, priceBreakdown };
        if (!payload.dclRental) delete payload.dclRental;
        if (!payload.dclParking) delete payload.dclParking;
        if (!payload.dclGarage) delete payload.dclGarage;
        if (isEmpty(payload.monthOfSecondInstallment) || Number(payload.advance) <= 0) {
            delete payload.monthOfSecondInstallment;
        }
        delete payload.industryOptions;
        dispatch(generatePrimerAiUrl(payload, setLoadingSave));
    };

    const copyToClipboard = () => {
        if (!newPrimerAiUrl.generatedUrl) return;
        navigator.clipboard.writeText(newPrimerAiUrl.generatedUrl).then(() => {
            toast.success("Το URL αντιγράφηκε");
        }).catch(() => {
            toast.error("Αποτυχία αντιγραφής");
        });
    };

    const clearForm = () => {
        dispatch(resetNewPrimerAiUrl());
        dispatch(setSavePrimerAiUrl(false));
        setShowErrors(false);
    };

    const loadUsersListData = (name, setData) => {
        axios.post(process.env.REACT_APP_API_URL2 + `/user/list-users`, {name: name, company: company.id}, {
            headers: {"Content-Type": "application/json"}
        }).then((res) => {
            if (res.data && res.data.status === "200") {
                if (res.data.data) {
                    setData(res.data.data);
                } else {
                    setData([]);
                }
            } else {
                setData([]);
            }
        }).catch((e) => {
            console.log(e);
        });
    };

    const fetchQuotations = (fromPagination = false) => {
        setLoading(true);
        let params = {
            ...requestData,
            company: company.id
        };
        if (!fromPagination) params.page = 1;
        if (!isAdmin) params.userId = user._id;

        axios.get(`${process.env.REACT_APP_API_URL2}/sale/get-ai-quotations`, {
            headers: { "Content-Type": "application/json" },
            params: params
        }).then((res) => {
            setLoading(false);
            if (res.data.status === "200") {
                if (!fromPagination) {
                    toast.dismiss();
                    if (res.data.data.length === 0) {
                        toast.info("Δεν βρέθηκαν αποτελέσματα.");
                    } else {
                        toast.success("Τα δεδομένα ανανεώθηκαν", {
                            autoClose: 1000,
                            toastId: "data-update-success"
                        });
                    }
                }
                if (!fromPagination) dispatch(setAiQuotationsRequestData({...requestData, page: 1}));
                dispatch(setAiQuotationsResponseData({data: res.data.data, totalPages: res.data.totalPages}));
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            setLoading(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        });
    };

    const sendEmail = (data, email, setLoading) => {
        if (setLoading) setLoading(true);
        if (!isEmpty(email)) {
            const emailPayload = {
                ...data,
                email: email
            };
            axios.post(apiURL2 + `/sale/send-primer-ai-url`, emailPayload, {
                headers: {"Content-Type": "application/json"},
            }).then((emailRes) => {
                if (emailRes.data.status === "200") {
                    toast.success(emailRes.data.message);
                    setEmail("");
                } else {
                    toast.warning(emailRes.data.message);
                }
            }).catch(() => toast.error("Σφάλμα κατά την αποστολή του email."));
        } else {
            toast.error("Δεν ορίστηκε email για αποστολή");
        }
    }

    const getActiveFields = (data) => {
        const allFields = [
            { label: "ΑΦΜ", value: data.vatNumber },
            { label: "ERP Version", value: data.erpVersion ? data.erpVersion.charAt(0).toUpperCase() + data.erpVersion.slice(1) : null },
            { label: "Χρήστες", value: data.numberOfUsers },
            { label: "Ψηφιακή κάρτα εργασίας", value: data.numberOfEmployees },
            { label: "Module MyData Report", value: data.myDataReport ? 'Ενεργό' : null },
            { label: "Τιμολόγηση Δημοσίου (B2G)", value: data.b2g ? 'Ενεργό' : null },
            { label: "Ενοικίαση Αυτοκινήτων", value: data.dclRental ? 'Ενεργό' : null },
            { label: "Πάρκινγκ - Πλυντήρια", value: data.dclParking ? 'Ενεργό' : null },
            { label: "Συνεργεία Αυτοκινήτων", value: data.dclGarage ? 'Ενεργό' : null },
            { label: "Παραστατικά ανά μήνα", value: data.documentsPerMonth },
            { label: "Όριο Εταιρειών", value: data.limitCompanies },
            { label: "Δελτίο Αποστολής", value: String(data.deliveryNote) === "true" ? "Ενεργό" : null },
            { label: "Λογιστικά Έντυπα", value: String(data.accountingForms) === "true" ? "Ενεργό" : null },
            { label: "Διαχείριση Λογαριασμών (Όψεως)", value: String(data.bankTransactions) === "true" ? "Ενεργό" : null },
            { label: "Διασύνδεση Λογαριασμών (Όψεως)", value: data.accountsNumber },
            { label: "AI Credits ανά μήνα", value: data.creditsPerMonth },
            { label: "Cloud Storage (Primer Connect)", value: data.cloudCapacity },
            { label: "Περίοδος χρέωσης", value: `${data.billingInterval} ${data.billingPeriod === 'month' ? 'Μήνας' : 'Έτος'}` },
            { label: "Προκαταβολή", value: Number(data.advance) > 0 ? getGreekCurrencyFormat(data.advance) : null },
            { label: "Μήνας 2ης Δόσης", value: Number(data.advance) > 0 ? data.monthOfSecondInstallment : null },
            { label: "Λήξη Προσφοράς", value: data.linkExpireAfter ? moment(data.linkExpireAfter).format("DD/MM/YYYY") : null }
        ];
        return allFields.filter(field => {
            const val = field.value;
            return !isEmpty(val) && val !== "0,00 €" && val !== 0;
        });
    };

    const positioningDetails = () => {
        const activeFields = getActiveFields(selectedQuotation);
        const itemsPerCol = Math.ceil(activeFields.length / 2);
        const col1 = activeFields.slice(0, itemsPerCol);
        const col2 = activeFields.slice(itemsPerCol, itemsPerCol * 2);
        return [col1, col2];
    };

    const onChangeSearch = (keyword, setData) => {
        if (String(keyword).length >= 2) {
            loadUsersListData(keyword, setData);
        }
    };

    const clearModalState = () => {
        setSelectedQuotation(null);
        setUsersList([]);
        setPageChanged(false);
        dispatch(setAiQuotationsRequestData({
            dateFrom: "",
            dateTo: "",
            user: "",
            page: 1,
            totalPages: 0
        }));
        dispatch(setAiQuotationsResponseData({
            data: [],
            totalPages: 0
        }));
    };

    const handleCopyQuotation = () => {
        if (!selectedQuotation) return;

        const { _id, __v, created_at, updated_at, ...cleanData } = selectedQuotation;
        const quotationToCopy = {
            ...newPrimerAiUrlInitialValue,
            ...cleanData,
            vatNumber: String(cleanData.vatNumber),
            generatedUrl: ""
        };

        dispatch(setNewPrimerAiUrl(quotationToCopy));
        if (!ACTIVITY.savePrimerAiUrl) dispatch(setSavePrimerAiUrl(true));
        handleCloseModal();
        toast.success("Η προσφορά αντιγράφηκε");
    };

    const handleCloseModal = () => {
        setShowQuotationsModal(false);
        clearModalState();
    };

    const handleShowModal = () => {
        dispatch(setAiQuotationsRequestData({
            ...requestData,
            dateFrom: moment().subtract(1, 'months').format("DD/MM/YYYY"),
            dateTo: moment().format("DD/MM/YYYY"),
            page: 1
        }));
        setShowQuotationsModal(true);
    };

    return (
        <React.Fragment>
            <div className="new-sales">
                <div className={"client-form product-form position-relative mb-2"}>
                    {isEmpty(newPrimerAiUrl.erpVersion) && <div className="overlay_w">Παρακαλώ επιλέξτε ERP Version πρώτα...</div>}
                    <Row>
                        <div className="text-muted mb-2"><i>Δεδομένα Πακέτου AI</i></div>
                        <Col xs={"12"} md={"2"} className="showWithOverlay">
                            <Dropdown
                                label={"ERP Version"}
                                key={getDefaultOptionByValue(erpVersionOptions, newPrimerAiUrl.erpVersion, 'value', 'label', 'value')}
                                defaultValue={getDefaultOptionByValue(erpVersionOptions, newPrimerAiUrl.erpVersion, 'value', 'label', 'value')}
                                name="erpVersion"
                                options={erpVersionOptions}
                                required={true}
                                onChange={(e) => handleOnChange(e, "dd", "erpVersion")}
                            />
                        </Col>
                        <Col xs={"12"} md={"2"}>
                            <Input
                                label={"Α.Φ.Μ. Πελάτη"}
                                className="mb-2 w-100 bg-white"
                                name="vatNumber"
                                type="text"
                                charLimit={20}
                                value={newPrimerAiUrl.vatNumber}
                                placeholder={"Α.Φ.Μ. Πελάτη"}
                                onChange={(e) => handleOnChange(e, "input", "vatNumber")}
                                required={true}
                            />
                            {showErrors && isEmpty(newPrimerAiUrl.vatNumber) && (
                                <div className="text-danger">{"Το πεδίο είναι υποχρεωτικό"}</div>
                            )}
                            {showErrors && !isEmpty(newPrimerAiUrl.vatNumber) && !validateAFM(newPrimerAiUrl.vatNumber) && (
                                <div className="text-danger">{"Το ΑΦΜ δεν είναι έγκυρο"}</div>
                            )}
                        </Col>
                        <Col xs={"12"} md={"2"}>
                            <Dropdown
                                label={"Αριθμός Χρηστών"}
                                key={getDefaultOptionByValue(numberOfUsersOptions, newPrimerAiUrl.numberOfUsers, 'value', 'label', 'value')}
                                defaultValue={getDefaultOptionByValue(numberOfUsersOptions, newPrimerAiUrl.numberOfUsers, 'value', 'label', 'value')}
                                name="numberOfUsers"
                                options={numberOfUsersOptions}
                                required={true}
                                onChange={(e) => handleOnChange(e, "dd", "numberOfUsers")}
                            />
                        </Col>
                        {newPrimerAiUrl.erpVersion === 'accountant' && (
                            <Col xs={"12"} md={"2"}>
                                <Dropdown
                                    label={"Όριο εταιρειών"}
                                    key={getDefaultOptionByValue(limitCompaniesOptions, newPrimerAiUrl.limitCompanies, 'value', 'label', 'value')}
                                    defaultValue={getDefaultOptionByValue(limitCompaniesOptions, newPrimerAiUrl.limitCompanies, 'value', 'label', 'value')}
                                    name="limitCompanies"
                                    options={limitCompaniesOptions}
                                    required={true}
                                    onChange={(e) => handleOnChange(e, "dd", "limitCompanies")}
                                />
                            </Col>
                        )}
                        {newPrimerAiUrl.erpVersion === 'gold' && (
                            <Col xs={"12"} md={"2"}>
                                <Dropdown
                                    label={"Παραστατικά ανά μήνα"}
                                    key={getDefaultOptionByValue(documentsPerMonthOptions, newPrimerAiUrl.documentsPerMonth, 'value', 'label', 'value')}
                                    defaultValue={
                                        newPrimerAiUrl.erpVersion === 'gold' ?
                                            getDefaultOptionByValue(documentsPerMonthOptions, newPrimerAiUrl.documentsPerMonth, 'value', 'label', 'value') :
                                            ""
                                    }
                                    name="documentsPerMonth"
                                    options={documentsPerMonthOptions}
                                    required={true}
                                    onChange={(e) => handleOnChange(e, "dd", "documentsPerMonth")}
                                />
                            </Col>
                        )}
                        <Col xs={"12"} md={"2"}>
                            <Dropdown
                                label={"AI Credits ανά μήνα"}
                                key={getDefaultOptionByValue(creditsPerMonthOptions, newPrimerAiUrl.creditsPerMonth, 'value', 'label', 'value')}
                                defaultValue={getDefaultOptionByValue(creditsPerMonthOptions, newPrimerAiUrl.creditsPerMonth, 'value', 'label', 'value')}
                                name="creditsPerMonth"
                                options={creditsPerMonthOptions}
                                required={newPrimerAiUrl.erpVersion === 'gold'}
                                onChange={(e) => handleOnChange(e, "dd", "creditsPerMonth")}
                            />
                        </Col>
                        <Col xs={"12"} md={"2"}>
                            <Dropdown
                                label={"Διαχείρηση Αρχείων Πελατών Cloud"}
                                key={getDefaultOptionByValue(cloudCapacityOptions, newPrimerAiUrl.cloudCapacity, 'value', 'label', 'value')}
                                defaultValue={getDefaultOptionByValue(cloudCapacityOptions, newPrimerAiUrl.cloudCapacity, 'value', 'label', 'value')}
                                name="cloudCapacity"
                                options={cloudCapacityOptions}
                                onChange={(e) => handleOnChange(e, "dd", "cloudCapacity")}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={"12"} md={"2"}>
                            <Dropdown
                                label={"Ψηφιακή Κάρτα Εργασίας"}
                                key={getDefaultOptionByValue(numberOfEmployeesOptions, newPrimerAiUrl.numberOfEmployees, 'value', 'label', 'value')}
                                defaultValue={getDefaultOptionByValue(numberOfEmployeesOptions, newPrimerAiUrl.numberOfEmployees, 'value', 'label', 'value')}
                                name="numberOfEmployees"
                                options={numberOfEmployeesOptions}
                                onChange={(e) => handleOnChange(e, "dd", "numberOfEmployees")}
                            />
                        </Col>
                        {newPrimerAiUrl.erpVersion === "gold" && (
                            <Col xs={"12"} md={"2"}>
                                <Dropdown
                                    label={"Ψηφιακό Πελατολόγιο"}
                                    defaultValue={industryOptions.filter(opt => {
                                        if (opt.value === "car renting") return newPrimerAiUrl.dclRental;
                                        if (opt.value === "parking - car washes") return newPrimerAiUrl.dclParking;
                                        if (opt.value === "car repair shop") return newPrimerAiUrl.dclGarage;
                                        return false;
                                    })}
                                    key={`${newPrimerAiUrl.dclRental}-${newPrimerAiUrl.dclParking}-${newPrimerAiUrl.dclGarage}`}
                                    name="industryOptions"
                                    options={industryOptions}
                                    multiSelect={true}
                                    onChange={(e) => handleOnChange(e, "dropdown", "industryOptions")}
                                />
                            </Col>
                        )}
                        <Col xs={"12"} md={"2"}>
                            <Dropdown
                                label={"Διασύνδεση Λογαριασμών (Όψεως)"}
                                key={getDefaultOptionByValue(accountsNumberOptions(newPrimerAiUrl.erpVersion), newPrimerAiUrl.accountsNumber, 'value', 'label', 'value')}
                                defaultValue={getDefaultOptionByValue(accountsNumberOptions(newPrimerAiUrl.erpVersion), newPrimerAiUrl.accountsNumber, 'value', 'label', 'value')}
                                name="accountsNumber"
                                options={accountsNumberOptions(newPrimerAiUrl.erpVersion)}
                                onChange={(e) => handleOnChange(e, "dd", "accountsNumber")}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={"12"} md={newPrimerAiUrl.erpVersion === "gold" ? "2" : "3"} className="d-flex align-items-center">
                            <Checkbox
                                className="mt-3"
                                name="bankTransactions"
                                text={"Διαχείριση Λογαριασμών (Όψεως)"}
                                id="bankTransactions"
                                value={newPrimerAiUrl.bankTransactions}
                                checked={newPrimerAiUrl.bankTransactions}
                                onChange={(e) => handleOnChange(e, "checkbox", "bankTransactions")}
                            />
                        </Col>
                        <Col xs={"12"} md={"2"} className="d-flex align-items-center" style={{
                            opacity: newPrimerAiUrl.erpVersion === "accountant" ? 0.5 : 1,
                            pointerEvents: newPrimerAiUrl.erpVersion === "accountant" ? 'none' : 'auto'
                        }}>
                        <Checkbox
                            className="mt-3"
                            name="myDataReport"
                            text={"Module MyData Report"}
                            id="myDataReport"
                            value={newPrimerAiUrl.myDataReport}
                            checked={newPrimerAiUrl.myDataReport}
                            onChange={(e) => handleOnChange(e, "checkbox", "myDataReport")}
                            disabled={newPrimerAiUrl.erpVersion === "accountant"}
                        />
                        </Col>
                        {newPrimerAiUrl.erpVersion === "accountant" && (
                            <Col xs={"12"} md={'2'} className="d-flex align-items-center">
                                <Checkbox
                                    className="mt-3"
                                    name="accountingForms"
                                    text={<span>Λογιστικά Έντυπα (Taxis){newPrimerAiUrl?.billingPeriod === "year" ? <><br /><span style={{color: "green"}}>(Δωρεάν για το 1ο έτος)</span></> : ""}</span>}
                                    id="accountingForms"
                                    value={newPrimerAiUrl.accountingForms}
                                    checked={newPrimerAiUrl.accountingForms}
                                    onChange={(e) => handleOnChange(e, "checkbox", "accountingForms")}
                                />
                            </Col>
                            )}
                        <Col xs={"12"} md={newPrimerAiUrl.erpVersion === "gold" ? "2" : "3"} className="d-flex align-items-center">
                            <Checkbox
                                className="mt-3"
                                name="deliveryNote"
                                text={"Διαχείριση Ψηφιακών Διακινήσεων"}
                                id="deliveryNote"
                                value={newPrimerAiUrl.deliveryNote}
                                checked={newPrimerAiUrl.deliveryNote}
                                onChange={(e) => handleOnChange(e, "checkbox", "deliveryNote")}
                            />
                        </Col>
                        <Col xs={"12"} md={"2"} className="d-flex align-items-center" style={{
                            opacity: newPrimerAiUrl.erpVersion === "accountant" ? 0.5 : 1,
                            pointerEvents: newPrimerAiUrl.erpVersion === "accountant" ? 'none' : 'auto'
                        }}>
                            <Checkbox
                                className="mt-3"
                                name="b2g"
                                text={"Τιμολόγηση Προς Δημόσιο (B2G)"}
                                id="b2g"
                                value={newPrimerAiUrl.b2g}
                                checked={newPrimerAiUrl.b2g}
                                onChange={(e) => handleOnChange(e, "checkbox", "b2g")}
                                disabled={newPrimerAiUrl.erpVersion === "accountant"}
                            />
                        </Col>
                    </Row>
                    <hr/>
                    <Row>
                        <div className="text-muted mb-2"><i>Δεδομένα Χρέωσης Πακέτου</i></div>
                        <Col xs={"12"} md={"2"}>
                            <Dropdown
                                label={"Διάστημα Χρέωσης"}
                                key={getDefaultOptionByValue(billingIntervalOptions, newPrimerAiUrl.billingInterval, 'value', 'label', 'value')}
                                defaultValue={getDefaultOptionByValue(billingIntervalOptions, newPrimerAiUrl.billingInterval, 'value', 'label', 'value')}
                                name="billingInterval"
                                options={billingIntervalOptions}
                                required={true}
                                onChange={(e) => handleOnChange(e, "dd", "billingInterval")}
                            />
                        </Col>
                        <Col xs={"12"} md={"2"}>
                            <Dropdown
                                label={"Περίοδος Χρέωσης"}
                                key={getDefaultOptionByValue(billingPeriodOptions, newPrimerAiUrl.billingPeriod, 'value', 'label', 'value')}
                                defaultValue={getDefaultOptionByValue(billingPeriodOptions, newPrimerAiUrl.billingPeriod, 'value', 'label', 'value')}
                                name="billingPeriod"
                                options={billingPeriodOptions}
                                required={true}
                                onChange={(e) => handleOnChange(e, "dd", "billingPeriod")}
                            />
                        </Col>
                        <Col xs={"12"} md={"2"}>
                            <FormLabel htmlFor="price">Τιμή Πακέτου</FormLabel>
                            <AccountingBox
                                key={priceIncrKey}
                                name="price"
                                placeholder={"Τιμή Πακέτου"}
                                defaultValue={newPrimerAiUrl.price}
                                onBlur={(e) => handleOnChange(e, 'input', 'price')}
                                disabled={Number(newPrimerAiUrl.billingInterval) < 12 && newPrimerAiUrl.billingPeriod === "month"}
                            />
                        </Col>
                        <Col xs={"12"} md={"2"}>
                            <FormLabel htmlFor="advance">Ποσό Προκαταβολής</FormLabel>
                            <AccountingBox
                                key={`price-${newPrimerAiUrl.vatNumber || 'empty'}`}
                                name="advance"
                                placeholder={"Ποσό Προκαταβολής"}
                                defaultValue={newPrimerAiUrl.advance}
                                onChange={(e) => handleOnChange(e, 'input', 'advance')}
                            />
                        </Col>
                        <Col xs={"12"} md={"2"}>
                            <Dropdown
                                label={"Μήνας Δεύτερης Δόσης"}
                                key={getDefaultOptionByValue(monthOfSecondInstallmentOptions, newPrimerAiUrl.monthOfSecondInstallment, 'value', 'label', 'value')}
                                defaultValue={
                                    Number(newPrimerAiUrl.advance) <= 0 || isEmpty(newPrimerAiUrl.advance) ? "" :
                                        getDefaultOptionByValue(monthOfSecondInstallmentOptions, newPrimerAiUrl.monthOfSecondInstallment, 'value', 'label', 'value')}
                                name="monthOfSecondInstallment"
                                options={monthOfSecondInstallmentOptions}
                                required={Number(newPrimerAiUrl.advance) > 0}
                                disabled={Number(newPrimerAiUrl.advance) <= 0 || isEmpty(newPrimerAiUrl.advance)}
                                onChange={(e) => handleOnChange(e, "dd", 'monthOfSecondInstallment')}
                            />
                            {showErrors && Number(newPrimerAiUrl.advance) > 0 && isEmpty(newPrimerAiUrl.monthOfSecondInstallment) && (
                                <div className="text-danger small">Επιλέξτε μήνα δόσης</div>
                            )}
                        </Col>
                        <Col xs={"12"} md={"2"}>
                            <DateBox
                                classes="w-100"
                                label={"Ημερομηνία Λήξης Προσφοράς"}
                                name="linkExpireAfter"
                                selected={newPrimerAiUrl.linkExpireAfter}
                                readOnly={false}
                                disabled={false}
                                required={true}
                                minDate={moment().toDate()}
                                onChange={(date) => handleOnChange(date, "datebox", "linkExpireAfter")}
                            />
                        </Col>
                    </Row>
                    <Row className="align-items-start">
                        <Col xs={"12"} md={"2"}>
                            <div style={{ marginTop: "22px" }}>
                                <Checkbox
                                    className={"mb-0"}
                                    name="sentLinkToEmail"
                                    text={"Αποστολή σε Email"}
                                    key={newPrimerAiUrl.sentLinkToEmail}
                                    id="vsent-link-to-email"
                                    checked={newPrimerAiUrl.sentLinkToEmail}
                                    value={newPrimerAiUrl.sentLinkToEmail}
                                    onChange={(e) => handleOnChange(e, "checkbox", "sentLinkToEmail")}
                                />
                            </div>
                        </Col>
                        <Col xs={"12"} md={"4"} style={{ minHeight: "85px" }}>
                            {newPrimerAiUrl.sentLinkToEmail && (
                                <>
                                    <Input
                                        name="email"
                                        charLimit={200}
                                        required={true}
                                        autoComplete={"off"}
                                        label={"Email"}
                                        placeholder={"Email"}
                                        value={newPrimerAiUrl.email}
                                        onChange={(e) => handleOnChange(e, "input", "email")}
                                    />
                                    {showErrors && isEmpty(newPrimerAiUrl.email) && (
                                        <div className="text-danger small">Παρακαλώ συμπληρώστε ένα Email</div>
                                    )}
                                    {showErrors && !isEmpty(newPrimerAiUrl.email) && !isValidEmail(newPrimerAiUrl.email) && (
                                        <div className="text-danger small">Το Email δεν είναι έγκυρο</div>
                                    )}
                                </>
                            )}
                        </Col>
                    </Row>
                    <Row className="justify-content-end align-items-start">
                        {!isEmpty(newPrimerAiUrl.generatedUrl) && (
                            <Col md={8}>
                                <Alert variant="success">
                                    <h6 className="alert-heading font-weight-bold">
                                        Το URL δημιουργήθηκε επιτυχώς:
                                    </h6>
                                    <hr/>
                                    <code className="text-dark d-block text-break mb-1">{newPrimerAiUrl.generatedUrl}</code>
                                    <Button size="xs" onClick={copyToClipboard} title={"Copy to clipboard"}>
                                        <i className={"fa fa-copy"}></i>
                                    </Button>
                                </Alert>
                            </Col>
                        )}
                        <Col md={4}>
                            <Accordion className="mb-3">
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>
                                        <span className="fw-semibold">
                                            Ανάλυση Τελικής Τιμής
                                        </span>
                                    </Accordion.Header>
                                    <Accordion.Body className="p-2">
                                        <table className="table table-sm table-borderless mb-0"
                                               style={{fontSize: "13px"}}>
                                            <tbody>
                                            {priceBreakdown.items.map((item, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <div>{item.label}</div>
                                                        <small className="text-muted">
                                                            {getGreekCurrencyFormat(item.monthlyPrice)}
                                                            {" / μήνα"}
                                                        </small>
                                                    </td>
                                                    <td className="text-end text-nowrap">
                                                        {getGreekCurrencyFormat(Number((item.monthlyPrice * priceBreakdown.months).toFixed(2)))}
                                                    </td>
                                                </tr>
                                            ))}

                                            {priceBreakdown.items.length === 0 && (
                                                <tr>
                                                    <td colSpan={2} className="text-muted text-center">
                                                        Δεν έχουν επιλεγεί υπηρεσίες.
                                                    </td>
                                                </tr>
                                            )}

                                            <tr className="border-top">
                                                <td>Μηνιαίο Κόστος</td>
                                                <td className="text-end fw-bold">
                                                    {getGreekCurrencyFormat(priceBreakdown.monthlySubtotal)}
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>Διάρκεια Χρέωσης</td>
                                                <td className="text-end">
                                                    {priceBreakdown.months} μήνες
                                                </td>
                                            </tr>

                                            <tr className="border-top">
                                                <td>Αυτόματη Τιμή Πακέτου</td>
                                                <td className="text-end fw-bold">
                                                    {getGreekCurrencyFormat(priceBreakdown.autoPrice)}
                                                </td>
                                            </tr>

                                            {manualPriceAdjustment !== 0 && (
                                                <tr>
                                                    <td>
                                                        {manualPriceAdjustment < 0 ? "Έκπτωση / Προσαρμογή" : "Επιπλέον Χρέωση / Προσαρμογή"}
                                                    </td>
                                                    <td className={`text-end fw-bold ${manualPriceAdjustment < 0 ? "text-success" : "text-danger"}`}>
                                                        {getGreekCurrencyFormat(manualPriceAdjustment)}
                                                    </td>
                                                </tr>
                                            )}
                                            <tr className="border-top">
                                                <td>Καθαρή Αξία</td>
                                                <td className="text-end fw-bold">
                                                    {getGreekCurrencyFormat(Number(newPrimerAiUrl.price))}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Φ.Π.Α. (24%)</td>
                                                <td className="text-end">
                                                    {getGreekCurrencyFormat(Number(newPrimerAiUrl.vat))}
                                                </td>
                                            </tr>

                                            <tr className="border-top bg-light">
                                                <td className="fw-bold">
                                                    Τελικό Σύνολο
                                                </td>
                                                <td className="text-end fw-bold">
                                                    {getGreekCurrencyFormat(Number(newPrimerAiUrl.total))}
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                            <table className="table table-bordered mb-3" style={{fontSize: "14px"}}>
                                <tbody>
                                    <tr className="bg-light">
                                        <td style={{textAlign: "center"}}>Σύνολα</td>
                                        <td style={{textAlign: "center"}}>Ποσό</td>
                                    </tr>
                                    <tr>
                                        <td className="fw-bold">Καθαρή Αξία</td>
                                        <td className="text-end">
                                            {getGreekCurrencyFormat(Number(newPrimerAiUrl.price))}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="fw-bold">Φ.Π.Α. (24%)</td>
                                        <td className="text-end">
                                            {getGreekCurrencyFormat(Number(newPrimerAiUrl.vat))}
                                        </td>
                                    </tr>
                                    <tr style={{backgroundColor: "#f8f9fa"}}>
                                        <td className="fw-bold" style={{fontSize: "16px"}}>Τελικό Σύνολο</td>
                                        <td className="fw-bold text-end" style={{fontSize: "16px"}}>
                                            {getGreekCurrencyFormat(Number(newPrimerAiUrl.total))}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                    <Row className="mt-2 align-items-center">
                        <Col xs={12} md={6} className="d-flex justify-content-start showWithOverlay">
                            <Button
                                variant="primary"
                                onClick={handleShowModal}
                            >
                                {"Προσφορές"}
                            </Button>
                        </Col>
                        <Col xs={12} md={6} className="d-flex justify-content-end">
                            <Button
                                variant="primary"
                                disabled={buttonDisabled() || loadingSave}
                                onClick={() => createUrl()}
                            >
                                {loadingSave ? (
                                    <Spinner className="ml-2" animation="border" variant="dark" />
                                ) : (
                                    "Δημιουργία URL"
                                )}
                            </Button>
                            {!isEmpty(newPrimerAiUrl.generatedUrl) && (
                                <Button
                                    className="ml-2"
                                    variant="primary"
                                    size="md"
                                    onClick={clearForm}
                                >
                                    Νέο URL
                                </Button>
                            )}
                        </Col>
                    </Row>
                </div>
            </div>
            <Modal backdrop={"static"} show={showQuotationsModal} onHide={handleCloseModal} dialogClassName={"modal65PercentWidth"}>
                <Modal.Header closeButton>
                    <Modal.Title>Προσφορές AI</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="border rounded p-2">
                        <Row>
                            <Col xs={12} md={4}>
                                <DateBox
                                    name="dateFrom"
                                    selected={requestData.dateFrom ? moment(requestData.dateFrom, "DD/MM/YYYY").toDate() : moment().subtract(1, 'months').toDate()}
                                    label={t('General.dateFrom')}
                                    onChange={(e) => handleOnChangeModal(e, "datebox", "dateFrom")}
                                />
                            </Col>
                            <Col xs={12} md={4}>
                                <DateBox
                                    name="dateTo"
                                    selected={requestData.dateTo ? moment(requestData.dateTo, "DD/MM/YYYY").toDate() : moment().toDate()}
                                    label={t('General.dateTo')}
                                    onChange={(e) => handleOnChangeModal(e, "datebox", "dateTo")}
                                />
                            </Col>
                            {isAdmin && (
                                <Col xs={12} md={4}>
                                    <AdvancedCombobox
                                        name="user"
                                        className="ac-select-dropdown"
                                        defaultValue={requestData.user}
                                        label={t("General.user")}
                                        data={usersList}
                                        onChange={(e) => handleOnChangeModal(e, "advancedCombobox", "user")}
                                        resetFilter={() => dispatch(setAiQuotationsRequestData({
                                            ...requestData,
                                            user: ""
                                        }))}
                                        onChangeSearch={onChangeSearch}
                                        excludeColumns={[]}
                                        columns={userDropdownColumns}
                                        deleteEnable={false}
                                        searchTableEnable={false}
                                        showTableOptionOnSelect={true}
                                        placeholder={t("General.name")}
                                        required={false}
                                        showInsertAddButton={false}
                                        hideSaveButton={true}
                                        hideInsertNewRow={true}
                                        inputFieldClasses="form-control"
                                    />
                                </Col>
                            )}
                        </Row>
                    </div>
                    <Row>
                        <Col xs={12} md={12} className="d-flex justify-content-end mt-2">
                            <Button
                                variant="primary"
                                size="md"
                                disabled={loading}
                                onClick={() => fetchQuotations(false)}
                            >
                                Εφαρμογή Φίλτρων
                            </Button>
                        </Col>
                    </Row>
                    <div className="mt-2">
                        {responseData.data.length > 0 && responseData.totalPages > 0 && (
                            <div className="d-flex justify-content-end pagination-wrapper">
                                <Pagination
                                    currentPage={requestData.page}
                                    totalPages={responseData.totalPages}
                                    handlePageChange={handlePageChange}
                                />
                            </div>
                        )}
                        <table className="table table-bordered mb-3 table-hover"  style={{ tableLayout: "fixed", width: "100%" }}>
                            <colgroup>
                                {tableColumns.map((col, idx) => (
                                    <col key={"colInGroup" + idx} style={{width: col.width}}></col>
                                ))}
                            </colgroup>
                            <thead>
                            <tr>
                                {tableColumns.map((col, idx) => (
                                    <th key={"ai-quotations-table-col" + idx} style={{fontWeight: "bold", textAlign: "center"}}>{col["name"]}</th>
                                ))}
                            </tr>
                            </thead>
                            <tbody>
                            {responseData.data.length > 0 ? responseData.data.map((row, idx) => {
                                const isSelected = selectedQuotation?._id === row._id;
                                return (
                                    <tr
                                        key={`ai-quotation-${idx}`}
                                        onClick={() => handleRowClick(row)}
                                        style={
                                            isSelected ? {
                                                backgroundColor:"#e8e8e8",
                                                cursor: "pointer",
                                                textAlign: "center"
                                            } : {
                                                cursor: "pointer",
                                                textAlign: "center"
                                            }
                                        }
                                    >
                                        <td>{moment(row.created_at).format("DD/MM/YYYY")}</td>
                                        <td>{row.erpVersion.charAt(0).toUpperCase() + row.erpVersion.slice(1)}</td>
                                        <td>{(row.vatNumber)}</td>
                                        <td>{getGreekCurrencyFormat(row.total)}</td>
                                        <td>{row.user}</td>
                                    </tr>
                                );
                            }) : (
                                <tr>
                                    <td colSpan="4" className="text-center">Δεν βρέθηκαν εγγραφές.</td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>
                    {selectedQuotation && (
                        <div className="border rounded p-3 bg-light shadow-sm mt-3 animate__animated animate__fadeIn">
                            <div className="d-flex justify-content-between align-items-center border-bottom-1-gray mb-2 pb-3">
                                <h4 className="mb-0 text-primary">Λεπτομέρειες Προσφοράς</h4>
                                <button
                                    type="button"
                                    className="close"
                                    aria-label="Close"
                                    title="Κλείσιμο"
                                    onClick={() => {
                                        setSelectedQuotation(null);
                                        setEmail("");
                                    }}
                                    style={{
                                        border: 'none',
                                        background: 'none',
                                        fontSize: '1.5rem',
                                        lineHeight: '1',
                                        fontWeight: '700',
                                        color: '#000',
                                        textShadow: '0 1px 0 #fff',
                                        opacity: '.5'
                                    }}
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <Row>
                                {positioningDetails().map((columnItems, idx) => (
                                    <Col md={4} key={`detail-col-${idx}`}>
                                        {columnItems.map((field, fIdx) => (
                                            <p key={`field-${fIdx}`}>
                                                <strong>{field.label}:</strong> {field.value ?? ""}
                                            </p>
                                        ))}
                                    </Col>
                                ))}
                                <Col md={4}>
                                    {selectedQuotation?.priceBreakdown && (
                                        <Accordion className="mb-3">
                                            <Accordion.Item eventKey="0">
                                                <Accordion.Header>
                                        <span className="fw-semibold">
                                            Ανάλυση Τελικής Τιμής
                                        </span>
                                                </Accordion.Header>
                                                <Accordion.Body className="p-2">
                                                    <table className="table table-sm table-borderless mb-0"
                                                           style={{fontSize: "13px"}}>
                                                        <tbody>
                                                        {selectedQuotation?.priceBreakdown?.items.map((item, index) => (
                                                            <tr key={index}>
                                                                <td>
                                                                    <div>{item.label}</div>
                                                                    <small className="text-muted">
                                                                        {getGreekCurrencyFormat(item.monthlyPrice)}
                                                                        {" / μήνα"}
                                                                    </small>
                                                                </td>
                                                                <td className="text-end text-nowrap">
                                                                    {getGreekCurrencyFormat(Number((item.monthlyPrice * selectedQuotation?.priceBreakdown.months).toFixed(2)))}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        {selectedQuotation?.priceBreakdown?.items?.length === 0 && (
                                                            <tr>
                                                                <td colSpan={2} className="text-muted text-center">
                                                                    Δεν έχουν επιλεγεί υπηρεσίες.
                                                                </td>
                                                            </tr>
                                                        )}

                                                        <tr className="border-top">
                                                            <td>Μηνιαίο Κόστος</td>
                                                            <td className="text-end fw-bold">
                                                                {getGreekCurrencyFormat(selectedQuotation?.priceBreakdown.monthlySubtotal)}
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td>Διάρκεια Χρέωσης</td>
                                                            <td className="text-end">
                                                                {selectedQuotation?.priceBreakdown.months} μήνες
                                                            </td>
                                                        </tr>

                                                        <tr className="border-top">
                                                            <td>Αυτόματη Τιμή Πακέτου</td>
                                                            <td className="text-end fw-bold">
                                                                {getGreekCurrencyFormat(selectedQuotation?.priceBreakdown.autoPrice)}
                                                            </td>
                                                        </tr>
                                                        <tr className="border-top">
                                                            <td>Καθαρή Αξία</td>
                                                            <td className="text-end fw-bold">
                                                                {getGreekCurrencyFormat(Number(selectedQuotation.price))}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Φ.Π.Α. (24%)</td>
                                                            <td className="text-end">
                                                                {getGreekCurrencyFormat(Number(selectedQuotation.vat))}
                                                            </td>
                                                        </tr>

                                                        <tr className="border-top bg-light">
                                                            <td className="fw-bold">
                                                                Τελικό Σύνολο
                                                            </td>
                                                            <td className="text-end fw-bold">
                                                                {getGreekCurrencyFormat(Number(selectedQuotation.total))}
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>
                                    )}
                                    <table className="table table-bordered mb-3" style={{fontSize: "14px"}}>
                                        <tbody>
                                        <tr className="bg-light">
                                            <td style={{textAlign: "center"}}>Σύνολα</td>
                                            <td style={{textAlign: "center"}}>Ποσό</td>
                                        </tr>
                                        <tr>
                                            <td className="fw-bold">Καθαρή Αξία</td>
                                            <td className="text-end">
                                                {getGreekCurrencyFormat(Number(selectedQuotation.price))}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="fw-bold">Φ.Π.Α. (24%)</td>
                                            <td className="text-end">
                                                {getGreekCurrencyFormat(Number(selectedQuotation.vat))}
                                            </td>
                                        </tr>
                                        <tr style={{backgroundColor: "#f8f9fa"}}>
                                            <td className="fw-bold" style={{fontSize: "16px"}}>Τελικό Σύνολο</td>
                                            <td className="fw-bold text-end" style={{fontSize: "16px"}}>
                                                {getGreekCurrencyFormat(Number(selectedQuotation.total))}
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </Col>
                            </Row>
                            <Row className="align-items-start no-gutters">
                                <Col xs={12} md={4} className="mr-2">
                                    <Input
                                        name="email"
                                        charLimit={200}
                                        autoComplete={"off"}
                                        label={"Email"}
                                        placeholder={"Email"}
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                    {!isEmpty(email) && !isValidEmail(email) && (
                                        <div className="text-danger small">Το Email δεν είναι έγκυρο</div>
                                    )}
                                </Col>
                                <Col xs={12} md="auto" style={{marginTop: "28px"}}>
                                    <Button
                                        size="sm"
                                        disabled={isEmpty(email) || !isValidEmail(email)}
                                        onClick={() => sendEmail(selectedQuotation, email, setLoading)}
                                    >
                                        Αποστολή Προσφοράς
                                    </Button>
                                </Col>
                                <Col className="d-none d-md-block"></Col>
                                <Col xs={12} md="auto" className="d-flex justify-content-end" style={{ marginTop: "28px" }}>
                                    <Button size="sm" onClick={handleCopyQuotation}>Αντιγραφή</Button>
                                </Col>
                            </Row>
                            {selectedQuotation.generatedUrl && (
                                <div className="mt-2 p-2 bg-white border rounded">
                                    <small className="text-muted d-block">URL Αγοράς:</small>
                                    <code className="text-dark">{selectedQuotation.generatedUrl}</code>
                                    <span
                                        className="text-muted"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            const url = selectedQuotation.generatedUrl;
                                            if (url) {
                                                navigator.clipboard.writeText(url)
                                                    .then(() => toast.success("Το URL αντιγράφηκε"))
                                                    .catch(() => toast.error("Αποτυχία αντιγραφής"));
                                            }
                                        }}
                                        style={{
                                            cursor: "pointer",
                                            padding: "1px",
                                            display: "inline-flex"
                                        }}
                                        title="Αντιγραφή"
                                    >
                                        <i className="fa fa-copy"></i>
                                    </span>
                                </div>
                            )}
                        </div>
                    )}
                </Modal.Body>
            </Modal>
        </React.Fragment>
    );
}

export default AiUrlGenerator;